export const INITIAL_TEXT_SELECTION_STATE = {
  firstSentenceId: null,
  lastSentenceId: null,
  startIndex: null,
  endIndex: null,
  text: ''
};
